"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLpSkeletonEndpointsForEnv = exports.endpoints = void 0;
var Environments;
(function (Environments) {
    Environments["dev"] = "dev";
    Environments["prod"] = "production";
    Environments["test"] = "test";
    Environments["stg"] = "staging";
})(Environments || (Environments = {}));
exports.endpoints = {
    [Environments.prod]: {
        renderProd: "https://myvideo.sundaysky.com/",
        renderEmbed: "https://myvideo.sundaysky.com/embed/",
        renderLambda: "https://lps-service.sundaysky.com/renderLandingPage",
        write: "https://lps-service.sundaysky.com/writeLandingPageConfiguration"
    },
    [Environments.stg]: {
        renderProd: "https://myvideo-stg.sundaysky.com/",
        renderEmbed: "https://myvideo-stg.sundaysky.com/embed/",
        renderLambda: "https://lps-service-stg.sundaysky.com/renderLandingPage",
        write: "https://lps-service-stg.sundaysky.com/writeLandingPageConfiguration"
    },
    [Environments.dev]: {
        renderProd: "https://myvideo-dev.sundaysky.com/",
        renderEmbed: "https://myvideo-dev.sundaysky.com/embed/",
        renderLambda: "https://lps-service-dev.sundaysky.com/renderLandingPage",
        write: "https://lps-service-dev.sundaysky.com/writeLandingPageConfiguration"
    },
    [Environments.test]: {
        renderProd: "https://myvideo-test.sundaysky.com/",
        renderEmbed: "https://myvideo-test.sundaysky.com/embed/",
        renderLambda: "https://lps-service-test.sundaysky.com/renderLandingPage",
        write: "https://lps-service-test.sundaysky.com/writeLandingPageConfiguration"
    }
};
const getLpSkeletonEndpointsForEnv = (env) => {
    switch (env) {
        case Environments.prod:
            return exports.endpoints[Environments.prod];
        case Environments.stg:
            return exports.endpoints[Environments.stg];
        case Environments.test:
            return exports.endpoints[Environments.test];
        case Environments.dev:
        default:
            return exports.endpoints[Environments.dev];
    }
};
exports.getLpSkeletonEndpointsForEnv = getLpSkeletonEndpointsForEnv;
//# sourceMappingURL=endpoints.js.map